/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'

import { MyHorseListParams } from 'models'
import { useAppSelector, useDebounce, useFetch, useFocusTopScreen, useIsMounted, useUpdateEffect } from 'hooks'
import { constants } from 'apps'
import Tabs from 'features/Ranking/components/Tabs'
import RankingContainer from './styled'
import { TWO_LINE } from 'assets/images'
import { TopRankingContainer } from 'features/Ranking/pages/styled'
import { SearchInput } from 'shared'
import rankingApi from 'apis/rankingApi'
import { useSearchParams } from 'react-router-dom'
import Loading from 'features/Ranking/components/Loading'
import { RankingDonate } from 'models/ranking'
import TopGuildList from 'features/Ranking/components/TopGuildList'
import { NUMBER } from 'apps/constants'
import { GUILD_MESSAGE } from 'i18n/constants'
import { useTranslation } from 'react-i18next'

const rankingDefaultParams: MyHorseListParams = {
  limit: 10,
  page: 1,
  search: null,
  filterByMonth: true
}

const Ranking = () => {
  useFocusTopScreen()
  const { t } = useTranslation()
  const isMounted = useIsMounted()
  const [searchParams, setSearchParams] = useSearchParams() as any
  const [searchValue, setSearchValue] = useState<string>('')
  const debounceSearchValue = useDebounce<string>(searchValue, constants.DEBOUNCE_TIME)
  const { profile } = useAppSelector(state => state)
  const [rankingParams, setRankingParams] = useState<MyHorseListParams>(rankingDefaultParams)
  const paramsSearch = Object.fromEntries(searchParams.entries())
  const [period, setPeriod] = useState<string>('YEAR_MONTH')
  const [listRank, setListRank] = useState<RankingDonate[]>([])
  const [pageCount, setPageCount] = useState<number>(0)
  const [numberUser, setNumberUser] = useState<string>('')
  const [textNotify] = useState(() => {
    const resultText = 'Rank will be reset on the first day of the month'
    return resultText
  })

  const { data: rankListResponse, loading } = useFetch(
    {
      fetcher: rankingApi.getRankingContributor,
      params: {
        ...rankingParams,
        guildId: profile?.guild_id,
        page: paramsSearch.page ? +paramsSearch.page : rankingParams.page,
        filterByMonth: period === 'YEAR_MONTH' ? true : false
      }
    },
    [rankingParams, profile?.guild_id, period]
  )

  const { data: myRanking }: any = useFetch(
    {
      fetcher: rankingApi.getMyRankingContributor,
      params: {
        guildId: profile?.guild_id,
        filterByMonth: period === 'YEAR_MONTH' ? true : false
      }
    },
    [period, profile?.guild_id]
  )

  useEffect(() => {
    if (!rankListResponse || !isMounted()) {
      return
    }
    setListRank(rankListResponse.records)
    setPageCount(rankListResponse.total_page)
    setNumberUser(rankListResponse.total.toString())
  }, [rankListResponse])

  useUpdateEffect(() => {
    setListRank([])
    setRankingParams({ ...rankingParams, page: NUMBER.ONE, search: searchValue })
  }, [debounceSearchValue])

  useEffect(() => {
    return () => {
      setRankingParams(rankingDefaultParams)
    }
  }, [])

  const handlePageClick = (event: any) => {
    setSearchParams({ page: event.selected + 1 })
    setRankingParams({ ...rankingParams, page: event.selected })
  }

  const handleSearchValueChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
    setSearchParams({ page: 1 })
  }

  const _onTabClick = (v: string) => {
    if (v === 'ALL_TIME') {
      rankingParams.filterByMonth = false
    } else {
      rankingParams.filterByMonth = true
    }
    setPeriod(v)
    setSearchParams({ page: 1 })
    setRankingParams({
      ...rankingParams,
      page: 1,
      search: searchValue
    })
  }

  return (
    <RankingContainer>
      <div className='head'>
        <h3>
          {t(`${GUILD_MESSAGE}.ankingOfContributors`)}
          <img src={TWO_LINE} alt='line' />
        </h3>
      </div>
      <TopRankingContainer>
        <div className='head-box'>
          <SearchInput
            searchValue={searchValue}
            handleSearchValueChanged={handleSearchValueChanged}
            customClass='search-horse-input'
            placeholder={'Search'}
          />
          {period === 'YEAR_MONTH' && (
            <div className='text-notify'>{textNotify}</div>
          )}
        </div>
        <Tabs onTabClick={_onTabClick} />
        {loading ? (
          <Loading />
        ) : (
          <TopGuildList
            data={listRank}
            handlePageClick={handlePageClick}
            pageCount={pageCount}
            paramsSearch={paramsSearch}
            numberUser={numberUser}
            debounceSearchValue={debounceSearchValue}
            myRankingData={myRanking}
          />
        )}
      </TopRankingContainer>
    </RankingContainer>
  )
}

export default Ranking
